export const LOGO = "/images/logo.png";
export const PHONE = "+91-9971494317";
export const PHONE_LINK = "tel:+919971494317";
export const CALL_NUMBER = "+91-9818864317";
export const CALL_LINK = "tel:+919818864317";
export const EMAIL = "kchanda63@gmail.com";
export const ADDRESS = "E-1065, Dwarka Sector 07, Ramphal Chowk, New Delhi 110077";
export const INSTAGRAM = "https://www.instagram.com/abhiinstitutedelhi/";
export const FACEBOOK = "https://www.facebook.com/abhiinstitute";
export const WHATSAPP_LINK = `https://wa.me/919971494317?text=${encodeURIComponent(
  "Hi, I'm interested in hotel management courses at ABHI Institute."
)}`;
export const MAP_EMBED =
  "https://www.google.com/maps?q=Abhi+Institute+of+Hotel+Management,+Ramphal+Chowk,+Dwarka+Sector+7,+New+Delhi+110077&output=embed";
export const DIRECTIONS_LINK =
  "https://www.google.com/maps/dir/?api=1&destination=Abhi+Institute+of+Hotel+Management,+Ramphal+Chowk,+Dwarka+Sector+7,+New+Delhi+110077";

export const IMAGES = {
  hero: "/images/campus-kitchen-2.jpg",
  kitchen: "/images/campus-kitchen-1.jpg",
  lobby: "/images/campus-restaurant.jpg",
  placement1: "/images/campus-kitchen-1.jpg",
  placement2: "/images/campus-restaurant.jpg",
  placement3: "/images/campus-kitchen-2.jpg",
};

export const STATS = [
  { value: "#2", label: "Ranked in Delhi" },
  { value: "100%", label: "Placement Record" },
  { value: "2008", label: "Founded" },
  { value: "UGC", label: "Recognised Programs" },
];

export const NAV_LINKS = [
  { label: "About", id: "#about" },
  { label: "Courses", id: "#courses" },
  { label: "Placements", id: "#placements" },
  { label: "Contact", id: "#contact" },
];

export const FAQS = [
  {
    q: "Who can apply for hotel management at ABHI?",
    a: "Anyone who has passed 10th or 12th from any stream. Degree programs (BSc, BHMCT, BVoc) need a 12th pass, while diplomas accept 10th pass students too.",
  },
  {
    q: "Can I pay the fees in installments?",
    a: "Yes. Every program is payable in easy EMIs — from 5 EMIs on diplomas up to 14 EMIs on the 4-year BHMCT degree. No hidden charges.",
  },
  {
    q: "Does ABHI really provide 100% placement?",
    a: "Yes — we have held a 100% placement record since 2008. Every graduating batch has been placed in leading hotels, resorts and cruise lines in India and abroad.",
  },
  {
    q: "Are international internships really included?",
    a: "Yes. Students get international internship and placement opportunities across France, Mauritius, Dubai, the Maldives and New Zealand.",
  },
  {
    q: "How do I apply or visit the campus?",
    a: "Fill the enquiry form below, call +91-9971494317, or message us on WhatsApp. A counsellor calls you back within 24 hours and can arrange a campus visit at Dwarka Sector 7.",
  },
];

export const PARTNERS = [
  "Taj",
  "Roseate",
  "Hyatt",
  "Holiday Inn",
  "Westin",
  "Marriott",
  "Oberoi",
  "The Leela",
];

export const EARNINGS = [
  { country: "Mauritius", amount: "₹40K" },
  { country: "France", amount: "₹1 Lakh" },
  { country: "New Zealand", amount: "₹2 Lakh" },
];

export const MARQUEE_ITEMS = [
  "Job Assurance in Top Hotels of India & Abroad",
  "Earn While You Learn",
  "100% Placement Record",
  "France",
  "Mauritius",
  "Dubai",
  "Maldives",
  "New Zealand",
  "International Internships",
];

export const COURSES = [
  {
    title: "BSc in Hotel Management",
    duration: "3 Years",
    eligibility: "12th Pass (any stream)",
    fees: "₹3.70 Lakh · 12 EMIs",
    type: "UGC Recognised Degree",
  },
  {
    title: "BHMCT",
    duration: "4 Years",
    eligibility: "12th Pass (any stream)",
    fees: "₹4.70 Lakh · 14 EMIs",
    type: "UGC Recognised Degree",
  },
  {
    title: "BVoc in Hotel Management",
    duration: "3 Years",
    eligibility: "12th Pass (any stream)",
    fees: "₹3.50 Lakh · 12 EMIs",
    type: "UGC Recognised Degree",
  },
  {
    title: "Diploma in Hotel Management + International Internship",
    duration: "1 Year + 6m International Exposure",
    eligibility: "10th / 12th Pass",
    fees: "₹2 Lakh · EMIs Available",
    type: "UGC Recognised",
    highlight: "International internship guaranteed — earn a stipend up to ₹40K/month abroad",
  },
  {
    title: "Diploma in Hotel Management",
    duration: "1 Year",
    eligibility: "10th / 12th Pass",
    fees: "₹1.15 Lakh · 5 EMIs",
    type: "UGC Recognised",
  },
  {
    title: "Diploma in Catering & Culinary Arts",
    duration: "1 Year",
    eligibility: "10th / 12th Pass",
    fees: "₹1.40 Lakh · 5 EMIs",
    type: "UGC + AHLEI Certified",
  },
];
